import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// hook para obtener los parametros de la url -> usarlo es query.get('nombre_del_parametro')
export function useSearchParams() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
